
import {  Image,  StyleSheet, Text, View, Switch, ScrollView, useWindowDimensions,TouchableOpacity, Linking, TextInput, Picker  } from 'react-native';
import React, {useState, useEffect} from 'react';
import logo from './../assets/logo-psihomaestru-3.png'; 
import { FontAwesome } from '@expo/vector-icons';
import RNPickerSelect from 'react-native-picker-select';


export default function Answers1({navigation, route}) {


  const { name } = route.params;
  const { tokenKey } = route.params;
  const { Diagnostic } = route.params;
  const { PUN_utilizatorID } = route.params;
  const { currentDate } = route.params;
  const { sectiune } = route.params;

  const windowHeight = useWindowDimensions().height;
  
  const [shouldShowMandatory, setShouldShowMandatory] = useState(false);


  const [isLoading, setLoading] = useState(false);


  const [age, setAge] = useState('');
  const [mediu, setMediu] = useState();
  const [ocupation, setOcupation] = useState('');
  const [sex, setSex] = useState ();

  // console.log('Diagnostic: '+ Diagnostic);
  // console.log('PUNutilizatorID:'+PUN_utilizatorID);
  // console.log('age: '+age)
  // console.log('mediu: '+mediu);
  // console.log('ocupation: '+ocupation);
  // console.log('sex: '+sex );

  useEffect(() => {
    setLoading(true);
  }, []);



  return (
    <View style={styles.container}>
      <Image source={logo} style={styles.logo} /> 
      <Text style={styles.h1}>Mulțumesc {name}.</Text> 
      <Text style={styles.h2}>Am terminat cu întrebările! Raspunsurile tale evidențiază o posibila afecțiune.{"\n"}{"\n"}
      Pentru a creea un raport complet, rog să îmi spui:
      </Text>

      <TextInput 
      name='age'
      style={styles.inputAge}
      placeholder='Vârsta'
      onChangeText={
          (val) => {setAge(val)}
      }
      />

      <TextInput 
      name='ocupatia'
      style={styles.inputOcupation}
      placeholder='Ocupația'
      onChangeText={
          (val) => {setOcupation(val)}
      }
      />
      <Text style={styles.h3}>Mediul în care trăiesti</Text>
      <RNPickerSelect
        onValueChange={(val) => setMediu(val)}
        items={[
            { label: 'Urban', value: 1 },
            { label: 'Rural', value: 2 },
        ]}
        style={pickerSelectStyles}
      />
      <Text style={styles.h3}>Genul</Text>
      <RNPickerSelect
        onValueChange={(val) => setSex(val)}
        items={[
            { label: 'Masculin', value: 1 },
            { label: 'Feminin', value: 2 },
            { label: 'Altul', value: 3 },
        ]}
        style={pickerSelectStyles}
      />
      {shouldShowMandatory ? (
          <Text style={styles.inputMando}>Te rog să completezi toate câmpurile de mai sus.</Text>
          ) : null
      }
      <TouchableOpacity
        style={styles.buttonPlay}
          onPress=
          { 
            () => {
              if (mediu !== undefined || sex !== undefined) {
                if (!age.trim()) {
                  setShouldShowMandatory(true);
                  return;
                }
                if (age <= 16)  {
                  setShouldShowMandatory(true);
                  return;
                }
                if (!ocupation.trim()) {
                  setShouldShowMandatory(true);
                  return;
                }
                setShouldShowMandatory(false);
                navigation.replace('Inregistrare', 
                  {
                    name:name,
                    tokenKey:tokenKey, 
                    Diagnostic:Diagnostic, 
                    PUN_utilizatorID:PUN_utilizatorID, 
                    age:age, 
                    mediu:mediu, 
                    ocupation:ocupation, 
                    sex:sex,
                    currentDate: currentDate,
                    sectiune: sectiune, 
                  }
                  );
                return;
              }
              setShouldShowMandatory(true);

            }
          }
        >
          <FontAwesome name="sign-in" size={24} color="black" />
        </TouchableOpacity>    
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#e9ebee',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    left: 20,
    alignSelf: 'flex-start',
    width: 200, 
    height: 50,
    bottom:10,
  },
  h1: {
    fontSize: 16,
    alignContent: "flex-start",
    alignSelf: 'flex-start',
    fontWeight: 'bold',
    left: 20,
    right: 10,
    color:"#6c1eb2",
    bottom:30,
    top:30,
  },
  h3: {
    fontSize: 14,
    alignContent: "center",
    alignSelf: 'center',
    right: 10,
    color:"#6c1eb2",
    bottom:30,
    top:30,
  },
  h2: {
    fontSize: 16,
    alignContent: "flex-start",
    left: 5,
    right: 10,
    color: "#3E473A",
    bottom:30,
    top: 30,
  },

  buttonPlay: {
    alignSelf: 'center',
    width: 50,
    height: 50,
    top:60,
    backgroundColor: '#EFEB88',
    borderRadius:25,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width:0,
      height:3,
    },
    shadowOpacity: 0.15,
    shadowRadius:6.46,
    elevation:9,
  },
  checkboxContainer: {
    flexDirection: "row",
    alignSelf: 'flex-start',
    left:20,
  },
  label1: {
    color: "#3E473A",
    fontSize: 14,
    top: 170,
    position: 'absolute',
  },
  Switch1: {
    top:50, 
    alignSelf: 'center',
    top: 160,
    position: 'absolute',
  },
  label2: {
    color: "#3E473A",
    fontSize: 14,
    top: 220,
    position: 'absolute',
  },
  Switch2: {
    top:50, 
    alignSelf: 'center',
    top: 210,
    position: 'absolute',
  },
  label3: {
    color: "#3E473A",
    fontSize: 14,
    top: 280,
    position: 'absolute',
  },
  Switch3: {
    top:50, 
    alignSelf: 'center',
    top: 270,
    position: 'absolute',
  },
  hyperlinkStyle: {
    color: 'blue',
  },
  inputMando: {
    color: 'red',
    top:50
  },
  inputAge: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
    borderWidth: 1,
    borderColor: '#777',
    padding: 8,
    margin: 10,
    width: 220,
    borderRadius:25,
    bottom: 20,
    top:30
  },
  inputOcupation: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
    borderWidth: 1,
    borderColor: '#777',
    padding: 8,
    margin: 10,
    width: 220,
    borderRadius:25,
    bottom: 20,
    top:20
  },
  inputMandoAge: {
    color: 'red'
  },
  inputMediu: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
    borderWidth: 1,
    borderColor: '#777',
    padding: 8,
    margin: 10,
    width: 140,
    borderRadius:25,
    bottom: 20,
    top:20
  },

});
const pickerSelectStyles = StyleSheet.create({
  inputIOS: {
    height: 40,
    fontSize: 16,
    borderWidth: 1,
    borderColor: 'gray',
    borderRadius: 25,
    color: 'black',
    paddingRight: 30, // to ensure the text is never behind the icon
    width: 140,
    bottom: 20,
    top:20,
    padding: 8,
    margin: 10,
    alignSelf: 'center',
    width:220,
  },
  inputAndroid: {
    height: 40,
    fontSize: 16,
    borderWidth: 0.5,
    borderColor: 'purple',
    borderRadius: 25,
    color: 'black',
    paddingRight: 30, // to ensure the text is never behind the icon
    width: 140,
    bottom: 20,
    top:20,
    padding: 8,
    margin: 10,
    alignSelf: 'center',
    width:220,
  },
  inputWeb: {
    height: 40,
    fontSize: 16,
    borderWidth: 0.5,
    borderColor: 'purple',
    borderRadius: 25,
    color: 'black',
    paddingRight: 30, // to ensure the text is never behind the icon
    width: 140,
    bottom: 20,
    top:20,
    padding: 8,
    margin: 10,
    alignSelf: 'center',
    width:220,
    backgroundColor: '#e9ebee',
  }
});
